import React from 'react';

/**
 * Shared component to display bearer medical information
 * Used in both public-facing scans and admin preview
 */
const BearerMedicalDisplay = ({ t, isVerbal, diseases, birthYear, sex, bloodType }) => {
	// Calculate age from birth year
	const calculateAge = (birthYear) => {
		if (!birthYear || birthYear === -1) return null;
		const currentYear = new Date().getFullYear();
		return currentYear - birthYear;
	};
	
	const age = calculateAge(birthYear);
	
	return (
		<div className="w-full">
			<h2 className="text-xl font-bold mb-3">{t('medical_information')}</h2>
			
			{/* Display diseases */}
			{diseases && diseases.length > 0 ? (
				<div className="space-y-3">
					{diseases.map((disease, index) => (
						<div key={index} className={`border-l-4 pl-3 ${index === 0 ? 'border-cyan-600 bg-cyan-50 p-3 rounded' : 'border-cyan-500'}`}>
							<h3 
								className={`${index === 0 ? 'text-cyan-900 font-bold' : 'text-gray-800 text-base font-semibold'}`}
								style={index === 0 ? { fontSize: '1.25rem' } : {}}
							>
								{disease.disease_text}
							</h3>
							{disease.user_details && (
								<p className={`text-sm mt-1 ${index === 0 ? 'text-cyan-800' : 'text-gray-600'}`}>{disease.user_details}</p>
							)}
						</div>
					))}
				</div>
			) : (
				<p className="text-gray-500 text-sm">{t('no_diseases_added')}</p>
			)}
			
			{/* Display additional medical information if available */}
			{(birthYear && birthYear !== -1) || (sex && sex !== 'unspecified') || (bloodType && bloodType !== 'unspecified') || isVerbal === false ? (
				<div className="mt-4 p-3 bg-blue-50 border-l-4 border-blue-500 rounded">
					<div className="text-sm text-blue-700 space-y-1">
						{birthYear && birthYear !== -1 && (
							<div>
								{t('birth_year')}: {birthYear}
								{age && <span> ({age} {t('years_old')})</span>}
							</div>
						)}
					{sex && sex !== 'unspecified' && <div>{t('sex')}: {
							sex === 'male' ? t('sex_male') :
							sex === 'female' ? t('sex_female') :
							sex
						}</div>}
						{bloodType && bloodType !== 'unspecified' && <div>{t('blood_type')}: {bloodType}</div>}
						{isVerbal === false && (
							<div className="font-semibold">{t('person_cannot_talk')}</div>
						)}
					</div>
				</div>
			) : null}
		</div>
	);
};

export default BearerMedicalDisplay;
